// extracted by mini-css-extract-plugin
module.exports = {"container":"pdf-preview-pdf-preview-container-fcec4fba","preview":"pdf-preview-pdf-preview-preview-f534d6c1"};